import React from "react";

const roles = [
  {
    org: "Broke Royals",
    subtitle: "Band",
    role: "Owner & Performer",
    dates: "May 2014 – Present",
    bullets: [
      "Manage all aspects of a nationally touring indie rock band: music composition, recording, distribution, publishing, booking, PR, and sync licensing",
      "Oversee catalog administration and royalty collections for 100% independently owned works",
    ],
    links: [
      { label: "brokeroyals.com", url: "https://brokeroyals.com" },
      { label: "Billboard Feature", url: "https://www.billboard.com/music/music-news/broke-royals-bad-chemicals-video-8484366/" },
    ],
  },
  {
    org: "DC Rock History Podcast",
    subtitle: null,
    role: "Creator & Host",
    dates: "September 2024 – Present",
    bullets: [
      "Host and produce a documentary-style interview podcast covering the history of Washington, DC's rock music scene",
      "Interviewed influential guests including Thurston Moore (Sonic Youth), Bartees Strange, and Bob Boilen (NPR's Tiny Desk Concerts, All Songs Considered), fostering industry relationships across labels, artists, and media",
    ],
    links: [
      { label: "dcrockpod.podbean.com", url: "https://dcrockpod.podbean.com/" },
      { label: "Washingtonian Feature", url: "https://washingtonian.com/2025/04/02/the-dc-rock-history-podcast-explores-key-local-albums/" },
    ],
  },
];

const MusicProfile = () => {
  return (
    <section id="music">
      <h2>Music Industry Profile</h2>
      <div className="music-profile-container">
        {roles.map((item) => (
          <div className="music-profile-card" key={item.org}>
            <div className="music-profile-header">
              <div>
                <h3 className="music-org">
                  {item.org}
                  {item.subtitle && <span className="music-subtitle"> ({item.subtitle})</span>}
                </h3>
                <p className="music-role">{item.role}</p>
              </div>
              <span className="music-dates">{item.dates}</span>
            </div>
            <ul className="music-bullets">
              {item.bullets.map((b) => (
                <li key={b}>{b}</li>
              ))}
            </ul>
            <div className="project-links">
              {item.links.map((link) => (
                <a key={link.url} href={link.url} target="_blank" rel="noopener noreferrer">
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default MusicProfile;
